// One entry per client-portal menu option, matching the connectPermissions
// columns. `supplies` covers both Supply Order and Supply Order History.
export const PERMISSION_OPTIONS = [
  { key: 'orderEntry', label: 'Order Entry' },
  { key: 'orderHistory', label: 'Order History' },
  { key: 'results', label: 'Results' },
  { key: 'supplies', label: 'Supplies' },
  { key: 'pickupRequest', label: 'Pickup Request' },
  { key: 'actionItems', label: 'Action Items' },
  { key: 'testDirectory', label: 'Test Directory' },
];
